<template>
    <div class="text-center">
        <div class="flex flex-col items-center justify-center gap-4">
            <button class="w-full bg-brand-lime text-brand-teal rounded-[3rem] py-4 flex items-center justify-center px-4 sm:px-8 text-left"
                type="button"
                @click="call"
                v-if="canInitiateCall && showCallButtons">
                <i class="far fa-phone text-2xl pr-3"></i>
                <div class="w-full">
                    <span class="block text-base font-medium leading-[1.1]">Call and Connect Me Now</span>
                </div>
            </button>

            <button v-if="hasCalendly && showCallButtons" class="w-full text-left bg-brand-teal-light text-white rounded-[3rem] py-4 flex items-center justify-center px-4 sm:px-8"
                type="button"
                @click="schedule">
                <i class="far fa-calendar text-2xl pr-3"></i>
                <div class="w-full">
                    <span class="block text-base font-medium leading-[1.1]">{{ scheduleButtonText }}</span>
                </div>
            </button>

            <a :href="'tel:'+phone" class="w-full bg-brand-lime text-brand-teal rounded-[3rem] py-4 flex items-center justify-center px-4 sm:px-8 text-left"
                    type="button"
                    @click="contact"
                    v-if="!showCallButtons && phone">
                <i class="far fa-phone text-2xl pr-3"></i>
                <div class="w-full">
                    <span class="block text-base font-semibold leading-[1.1]">{{ phoneDisplay }}</span>
                </div>
            </a>

            <a :href="'mailto:'+email" class="w-full text-left bg-brand-teal-light text-white rounded-[3rem] py-4 flex items-center justify-center px-4 sm:px-8"
                    type="button"
                    @click="contact"
                    v-if="!showCallButtons && email">
                <i class="far fa-envelope text-2xl pr-3"></i>
                <div class="w-full">
                    <span class="block text-base font-semibold leading-[1.1]">{{ email }}</span>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import state from './store/state';

    export default {
        props: {
          showCallButtons: {
              type: Boolean,
              default: true,
          },
            phoneDisplay: {
                type: String,
                default: '',
            },
            phone: {
              type: String,
              default: '',
            },
            email: {
              type: String,
                default: '',
            }
        },
        created() {
            if (!this.$store.hasModule('call')) {
                this.$store.registerModule('call', state);
            }
        },

        computed: {
            scheduleButtonText() {
                return this.hasScheduledCall
                    ? 'Reschedule Your Appointment'
                    : 'Schedule an Appointment for Later';
            },

            ...mapGetters([
                'directConnect',
                'hasCalendly',
                'hasScheduledCall',
                'canInitiateCall',
            ])
        },

        methods: {
            contact() {
                this.scrollToInterface('contact-details');
            },

            call() {
                this.scrollToInterface('direct-connect-interface');
                this.$store.commit('started', true);
                this.$event.$emit('start-call');
            },

            schedule() {
                this.scrollToInterface('direct-connect-interface');
                this.$store.commit('started', true);
                this.$store.commit('modal', 'schedule-appointment');
            },

            scrollToInterface(id) {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        },
    }
</script>
